import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const CreateAwardModal = ({ open, handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
  });

  const initialFormData = {
    name: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Create Award</Typography>
          <div>
            <TextField
              id="name"
              label="Name"
              name="name"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.name}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAwardModal;
